import { render } from "./upload-scans.vue?vue&type=template&id=0af78c9e&scoped=true"
import script from "./upload-scans.vue?vue&type=script&lang=js"
export * from "./upload-scans.vue?vue&type=script&lang=js"

import "./upload-scans.vue?vue&type=style&index=0&id=0af78c9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\softw\\Documents\\Software\\Projects\\CodeRedLabs\\manila-customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af78c9e"]])

export default __exports__